import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addError, getCallId, getUserData } from "../../Redux/UserSlice";
import {
  backendApi,
  callPlayBot,
  FinishApi,
  LiveCallApi,
  ThankYouApi,
} from "../../services/service";
import * as Scroll from "react-scroll";
import LoaderComp from "../../LoaderComp";


var scroll = Scroll.scroller;
var Element = Scroll.Element;
// const user = {
//   user_id: "155ff86d-1d55-11ed-9798-e9bd8fb91d11",
//   msisdn: "9108273014",
//   status: "INITIATED",
//   language: "en",
//   application_number: "EA028551091",
//   policy_owner_name: "Kinshuk",
//   insured_name: "Kinshuk 1",
//   nominee_name: "Kinshuk 2",
//   email: "kinshuk.sharma@ubona.com",
//   address: "abc def",
//   city: "NOIDA",
//   state: "NA",
//   plan_name: "ABSLI DigiShield Plan",
//   purpose_of_insurance: "Risk",

//   plan_type:
//     "A Non-Linked Non-Participating Individual Pure Risk Premium Life Term Insurance Plan",
//   payment_frequency: "Annual",
//   policy_term: 24,
//   payment_term: 24,
//   pincode: 201303,
//   insured_dob: 977011200000,
//   policy_owner_dob: 1630540800000,
//   premium_amount: 65554.92,
//   sum_assured: 2.18e7,
//   flow_type: "hdfc",
//   product: "non par",
//   occupation: "something",
//   income: 5000.0,
//   la_contact: "test",
//   vrm_or_rbb_flag: "rbb",
// };
const HdfcScripts = ({ setPage, languageContent }) => {
  const dispatch = useDispatch();
  const call_id = useSelector(getCallId);
  const user = useSelector(getUserData);
 
  const [showButtons, setShowButtons] = useState(false);
  const [liveCallResponse, setLiveCallResponse] = useState(false);
  const [checked, setChecked] = useState(false);
  const [template, setTemplate] = useState("");
  const template_hdfc_scripts = async (_template, timeout=0) => {
    window.scroll({top: 0, left: 0, behavior: 'smooth' })
    await callPlayBot(call_id, _template)
      .then((res) => {
        console.log("this is res",res)
        if (res.status === 200) {
          setTimeout(() => {
            // console.log("ran after timeout");
            setShowButtons(true);
            setChecked(true)
          },timeout)
        }
      })
      .catch((e) => console.log(e.message));
  };
  const submitApi = async (key, value) => {
    await backendApi(call_id, key, value)
      .then((res) => {
        if (res.data) {
          // setPage("verification");
          console.log(res.data);
        }
      })
      .catch((e) => {
        dispatch(addError(e.message));
        setPage("sorryPage");
      });
    await LiveCallApi(call_id)
      .then((res) => {
        console.log(res.data);
        if (res.data === false) {
          setShowButtons(true);
          if (user?.flow_type && user?.flow_type?.toLowerCase() === "hdfc") {
            // setPage('callDisconnected')
          }
        }
        setLiveCallResponse(true);
      })
      .catch((e) => {
        setPage("sorryPage");
      });
  };

  useEffect(() => {
    if(Object.keys(user).length > 0) {
      console.log("running effect", user)
      let isEnglish = user.language.toLowerCase() === "en" ||
            user.language.toLowerCase() === "english"
      if(user?.vrm_or_rbb_flag && user.vrm_or_rbb_flag.toLowerCase() === "rbb") {
        if(user.product.toLowerCase() == "ulip") {
          template_hdfc_scripts(isEnglish ?  "ulip_rbb_en" : "ulip_rbb_hin", isEnglish ?   108000 : 114000);
          setTemplate("ulip_rbb_en");
        }
        else if(user.product.toLowerCase() == "par") {
          template_hdfc_scripts( isEnglish ? "par_rbb_en" : "par_rbb_hin", isEnglish ?  103000 : 108000);
          setTemplate("par_rbb_en");
        }
        else if(user.product.toLowerCase() == "non par") {
          template_hdfc_scripts( isEnglish ? "non_par_rbb_en" : "non_par_rbb_hin", isEnglish ?  100000 : 152000);
          setTemplate("non_par_rbb_en");
        }
        else {
          setPage("sorryPage");
        }
      }else if(user?.vrm_or_rbb_flag && user.vrm_or_rbb_flag.toLowerCase() === "vrm"){
        if(user.product.toLowerCase() == "ulip") {
          template_hdfc_scripts( isEnglish ? "ulip_vrm_en" : "ulip_vrm_hin", isEnglish ?  111000 : 125000);
          setTemplate("ulip_vrm_en");
        }
        else if(user.product.toLowerCase() == "par") {
          template_hdfc_scripts( isEnglish ? "par_vrm_en" : "par_vrm_hin", isEnglish ?  118000 : 124000);
          setTemplate("par_vrm_en");
        }
        else if(user.product.toLowerCase() == "non par") {
          template_hdfc_scripts(isEnglish ? "non_par_vrm_en" : "non_par_vrm_hin", isEnglish ?  115000 : 120000);
          setTemplate("non_par_vrm_en");
        }
        else {
          setPage("sorryPage");
        } 
      }else {
        setPage("sorryPage");
      }
    }
  },[user])

  useEffect(() => {
    console.log("ye chala");
    if (user?.flow_type && user?.flow_type?.toLowerCase() === "hdfc") {
      let delay = 0,
        duration = 0;
      if (
        user.language.toLowerCase() === "en" ||
        user.language.toLowerCase() === "english"
      ) {
        delay = 45000;
        duration =
          user.product && user.product.toLowerCase() === "ulip"
            ? 200000
            : 150000;
      } else {
        delay = 35000;
        duration =
          user.product && user.product.toLowerCase() === "ulip"
            ? 220000
            : 170000;
      }
      scroll.scrollTo("myScrollToElement", {
        duration: duration,
        ignoreCancelEvents: false,
        smooth: true,
        delay: delay,
      });
    }
    submitApi("hdfc_script_page", "open");
    
    return () => {
      // clearTimeout(id);
      Scroll.animateScroll.scrollToTop();
    };
  }, []);

  const handleAgreeInformation = async () => {
    if (!checked) {
    } else {
      await backendApi(call_id, "hdfc_scripts", "agree")
        .then((res) => {
          if (res.data) {
            setPage("video");
          }
        })
        .catch((e) => {
          console.log(e.message);
          setPage("sorryPage");
        });
    }
  };

  const handleDisagreeInformation = async () => {
    await ThankYouApi(call_id)
      .then((res) => console.log(res.data))
      .catch((e) => {
        dispatch(addError(e.message));
        setPage("sorryPage");
      });
    await FinishApi(call_id)
      .then((res) => setPage("thankYou"))
      .catch((e) => {
        dispatch(addError(e.message));
        setPage("sorryPage");
      });
  };

  return liveCallResponse ? (
    <div style={{ textAlign: "justify" }}>
      <div className="heading">
        <p>{languageContent.hdfc_disclaimer_page.title}</p>
      </div>
      <div style={{ marginTop: "10px" }}>
        {user.vrm_or_rbb_flag.toLowerCase() === "rbb" ? (
          user.product && user.product?.toLowerCase() === "ulip" ? (
            user.language.toLowerCase() === "en" ||
            user.language.toLowerCase() === "english" ? (
              <>
                <li>
                  As per your voluntary inputs during need analysis, you have
                  applied for <b>{user?.plan_name}</b> from{" "}
                  <b>Aditya Birla Sun Life Insurance</b> which is appropriate based on your
                  life insurance suitability profiler. This is a stand-alone
                  product for a term of <b>{user?.policy_term}</b> years.
                  Premium is INR <b>{user.premium_amount}</b> along with the
                  applicable taxes, which you need to pay for{" "}
                  <b>{user?.payment_term}</b> years on a{" "}
                  <b>{user?.payment_frequency}</b> basis. You may lose on policy
                  benefits if you do not pay premium for complete payment term.
                  Withdrawals are allowed only after completion of 5 policy
                  years.
                </li>
                {languageContent.hdfc_disclaimer_page.rbb.ulip_points.map(
                  (item) => (
                    <li>{item.content}</li>
                  )
                )}
              </>
            ) : <>
            <li>
            आवश्यकता विश्लेषण के दौरान आपके स्वैच्छिक इनपुट के अनुसार, आपने <b>आदित्य बिरला सुन लाइफ इन्शुरन्स </b> से <b>{user?.plan_name}</b> के लिए आवेदन किया है जो आपके जीवन बीमा उपयुक्तता प्रोफाइलर के आधार पर उपयुक्त है। यह <b>{user?.policy_term}</b> वर्षों की अवधि के लिए एक स्टैंड-अलोन उत्पाद है। प्रीमियम INR <b>{user.premium_amount}</b> है, साथ ही लागू करों के साथ, जिसे आपको <b>{user?.payment_frequency}</b> के आधार पर <b>{user?.payment_term}</b> वर्षों के लिए भुगतान करना होगा। यदि आप पूर्ण भुगतान अवधि के लिए प्रीमियम का भुगतान नहीं करते हैं, तो आप पॉलिसी लाभों से वंचित हो सकते हैं। निकासी की अनुमति केवल 5 पॉलिसी वर्ष पूरे होने के बाद ही दी जाती है। आप उत्पाद के सभी नियमों और शर्तों के बारे में जानने के लिए पॉलिसी दस्तावेज़ का संदर्भ ले सकते हैं और किसी भी मुद्दे के मामले में 30 दिनों की उपलब्ध फ्री-लुक अवधि के दौरान बीमाकर्ता या बैंक से संपर्क कर सकते हैं।
            </li>
            {languageContent.hdfc_disclaimer_page.rbb.ulip_points.map(
                  (item) => (
                    <li>{item.content}</li>
                  )
                )}
            </>
          ) : user.product && user.product?.toLowerCase() === "par" ? (
            user.language.toLowerCase() === "en" ||
            user.language.toLowerCase() === "english" ? (
              <>
                <li>
                  As per your voluntary inputs during need analysis, you have
                  applied for <b>{user?.plan_name}</b> from{" "}
                  <b>Aditya Birla Sun Life Insurance</b> which is appropriate based on your
                  life insurance suitability profiler. This is a stand-alone
                  product for a term of <b>{user?.policy_term}</b> years.
                  Premium is INR <b>{user.premium_amount}</b> along with the
                  applicable taxes which you need to pay for{" "}
                  <b>{user?.payment_term}</b> years on a{" "}
                  <b>{user?.payment_frequency}</b> basis. Kindly note that
                  bonuses are not guaranteed.
                </li>
                
                

                {languageContent.hdfc_disclaimer_page.rbb.par_points.map(
                  (item) => {
                    if(item.type == 'interpolated'){
                      return <li>
                      You will receive policy benefits as per benefit illustration shared.
                    </li>
                    }else return <li>{item.content}</li>
                    
                    }
                )}
              </>
            ) : <>
            <li>आवश्यकता विश्लेषण के दौरान आपके स्वैच्छिक इनपुट के अनुसार, आपने <b>आदित्य बिरला सुन लाइफ इन्शुरन्स </b> से <b>{user?.plan_name}</b> के लिए आवेदन किया है जो आपके जीवन बीमा उपयुक्तता प्रोफाइलर के आधार पर उपयुक्त है। यह <b>{user?.policy_term}</b> वर्षों की अवधि के लिए एक स्टैंड-अलोन उत्पाद है। प्रीमियम <b>{user.premium_amount}</b> है, साथ ही लागू करों के साथ जो आपको <b>{user?.payment_frequency}</b> के आधार पर भुगतान करने की आवश्यकता है। कृपया ध्यान दें कि बोनस की गारंटी नहीं है। आप उत्पाद के सभी नियमों और शर्तों के बारे में जानने के लिए पॉलिसी दस्तावेज़ का संदर्भ ले सकते हैं और किसी भी मुद्दे के मामले में 30 दिनों की उपलब्ध फ्री-लुक अवधि के दौरान बीमाकर्ता या बैंक से संपर्क कर सकते हैं।</li>
            {languageContent.hdfc_disclaimer_page.rbb.par_points.map(
                  (item) => (
                    <li>{item.content}</li>
                  )
                )}
            </>
            
          ) : user.product && user.product?.toLowerCase() === "non par" ? (
            user.language.toLowerCase() === "en" ||
            user.language.toLowerCase() === "english" ? (
              <>
                <li>
                  As per your voluntary inputs during need analysis, you have
                  applied for <b>{user?.plan_name}</b> from{" "}
                  <b>Aditya Birla Sun Life Insurance</b> which is appropriate based on your
                  life insurance suitability profiler. This is a stand-alone
                  product for a term of <b>{user?.policy_term}</b> years.
                  Premium is INR <b>{user.premium_amount}</b> along with the
                  applicable taxes which you need to pay for{" "}
                  <b>{user?.payment_term}</b> years on a{" "}
                  <b>{user?.payment_frequency}</b> basis. 
                </li>
                

                {languageContent.hdfc_disclaimer_page.rbb.non_par_points.map(
                  (item) => {
                    if(item.type == 'interpolated'){
                      return <li>
                      You will receive policy benefits as per benefit illustration shared.
                    </li>
                    }else return <li>{item.content}</li>
                    
                    }
                )}
              </>
            ) : <>
            <li>आवश्यकता विश्लेषण के दौरान आपके स्वैच्छिक इनपुट के अनुसार, आपने <b>आदित्य बिरला सुन लाइफ इन्शुरन्स </b> से <b>{user?.plan_name}</b> के लिए आवेदन किया है जो आपके जीवन बीमा उपयुक्तता प्रोफाइलर के आधार पर उपयुक्त है। यह <b>{user?.policy_term}</b> वर्षों की अवधि के लिए एक स्टैंड-अलोन उत्पाद है। प्रीमियम <b>{user.premium_amount}</b> है, साथ ही लागू करों के साथ जो आपको <b>{user?.payment_frequency}</b> के आधार पर <b>{user?.payment_term}</b> वर्षों के लिए भुगतान करने की आवश्यकता है। कृपया ध्यान दें कि बोनस की गारंटी नहीं है। आप उत्पाद के सभी नियमों और शर्तों के बारे में जानने के लिए पॉलिसी दस्तावेज़ का संदर्भ ले सकते हैं और किसी भी मुद्दे के मामले में 30 दिनों की उपलब्ध फ्री-लुक अवधि के दौरान बीमाकर्ता या बैंक से संपर्क कर सकते हैं।</li>
            {languageContent.hdfc_disclaimer_page.rbb.non_par_points.map(
                  (item) => (
                    <li>{item.content}</li>
                  )
                )}
            </>
          ) : null
        ) : user.vrm_or_rbb_flag.toLowerCase() === "vrm" ? (
          user.product && user.product?.toLowerCase() === "ulip" ? (
            user.language.toLowerCase() === "en" ||
            user.language.toLowerCase() === "english" ? (
              <>
                <li>
                  With reference to your telephonic conversation with HDFC bank
                  and as per your voluntary inputs during need analysis, you
                  have applied for <b>{user?.plan_name}</b> from{" "}
                  <b>Aditya Birla Sun Life Insurance</b> which is appropriate based on your
                  life insurance suitability profiler. This is a stand-alone
                  product for a term of <b>{user?.policy_term}</b> years.
                  Premium is INR <b>{user.premium_amount}</b> along with the
                  applicable taxes which you need to pay on a{" "}
                  <b>{user?.payment_frequency}</b> basis. Withdrawals are allowed only after completion of 5 policy years.
                </li>
                {languageContent.hdfc_disclaimer_page.vrm.ulip_points.map(
                  (item) => (
                    <li>{item.content}</li>
                  )
                )}
              </>
            ) : <>
            <li>एचडीएफसी बैंक के साथ आपकी टेलीफोनिक बातचीत के संदर्भ में और आवश्यकता विश्लेषण के दौरान आपके स्वैच्छिक इनपुट के अनुसार, आपने <b>आदित्य बिरला सुन लाइफ इन्शुरन्स </b> से <b>{user?.plan_name} </b> के लिए आवेदन किया है जो आपके जीवन बीमा उपयुक्तता प्रोफाइलर के आधार पर उपयुक्त है। यह <b>{user?.policy_term}</b> वर्षों की अवधि के लिए एक स्टैंड-अलोन उत्पाद है। प्रीमियम INR <b>{user.premium_amount}</b> है, साथ ही लागू करों के साथ जो आपको <b>{user?.payment_frequency}</b> के आधार पर भुगतान करने की आवश्यकता है। 5 पॉलिसी वर्ष पूरे होने के बाद ही निकासी की अनुमति है। आप उत्पाद के सभी नियमों और शर्तों के बारे में जानने के लिए पॉलिसी दस्तावेज़ और लाभ चित्रण का संदर्भ ले सकते हैं और किसी भी मुद्दे के मामले में 30 दिनों की फ्री-लुक अवधि के दौरान बीमाकर्ता या बैंक से संपर्क कर सकते हैं।</li>
            {languageContent.hdfc_disclaimer_page.vrm.ulip_points.map(
                  (item) => (
                    <li>{item.content}</li>
                  )
                )}
            </>
          ) : user.product && user.product?.toLowerCase() === "par" ? (
            user.language.toLowerCase() === "en" ||
            user.language.toLowerCase() === "english" ? (
              <>
               <li>
                  With reference to your telephonic conversation with HDFC bank and as per your voluntary inputs during need analysis, you have applied for <b>{user?.plan_name}</b> from{" "} <b>Aditya Birla Sun Life Insurance</b> which is appropriate based on your life insurance suitability profiler.  This is a stand-alone product for a term of <b>{user?.policy_term}</b> years.Premium is INR <b>{user.premium_amount}</b> along with the applicable taxes which you need to pay on a <b>{user?.payment_frequency}</b> basis. Kindly note that bonuses are not guaranteed. You can refer to the policy document & benefits illustration to know about all the terms and conditions of the product and approach the Insurer or Bank during the free-look period of 30 days in case of any issue.
                </li>
                

                {languageContent.hdfc_disclaimer_page.vrm.par_points.map(
                  (item) => (
                    <li>{item.content}</li>
                  )
                )}
              </>
            ) : <>
            <li>एचडीएफसी बैंक के साथ आपकी टेलीफोनिक बातचीत के संदर्भ में और आवश्यकता विश्लेषण के दौरान आपके स्वैच्छिक इनपुट के अनुसार, आपने <b>आदित्य बिरला सुन लाइफ इन्शुरन्स </b> से <b>{user?.plan_name} </b> के लिए आवेदन किया है जो आपके जीवन बीमा उपयुक्तता प्रोफाइलर के आधार पर उपयुक्त है। यह <b>{user?.policy_term}</b> वर्षों की अवधि के लिए एक स्टैंड-अलोन उत्पाद है। प्रीमियम <b>{user.premium_amount}</b> है, साथ ही लागू करों के साथ जो आपको <b>{user?.payment_frequency}</b> के आधार पर <b>{user?.payment_term}</b> वर्षों के लिए भुगतान करने की आवश्यकता है। कृपया ध्यान दें कि बोनस की गारंटी नहीं है। आप उत्पाद के सभी नियमों और शर्तों के बारे में जानने के लिए पॉलिसी दस्तावेज़ और लाभ चित्रण का संदर्भ ले सकते हैं और किसी भी मुद्दे के मामले में 30 दिनों की फ्री-लुक अवधि के दौरान बीमाकर्ता या बैंक से संपर्क कर सकते हैं।</li>
            {languageContent.hdfc_disclaimer_page.vrm.par_points.map(
                  (item) => (
                    <li>{item.content}</li>
                  )
                )}
            </>
          ) : user.product && user.product?.toLowerCase() === "non par" ? (
            user.language.toLowerCase() === "en" ||
            user.language.toLowerCase() === "english" ? (
              <>
                <li>
                  With reference to your telephonic conversation with HDFC bank and as per your voluntary inputs during need analysis, you have applied for <b>{user?.plan_name}</b> from{" "} <b>Aditya Birla Sun Life Insurance</b> which is appropriate based on your life insurance suitability profiler.  This is a stand-alone product for a term of <b>{user?.policy_term}</b> years.Premium is INR <b>{user.premium_amount}</b> along with the applicable taxes which you need to pay on a <b>{user?.payment_frequency}</b> basis. You can refer to the policy document & benefits illustration to know about all the terms and conditions of the product and approach the Insurer or Bank during the free-look period of 30 days in case of any issue.
                </li>
                

                {languageContent.hdfc_disclaimer_page.vrm.non_par_points.map(
                  (item) => (
                    <li>{item.content}</li>
                  )
                )}
              </>
            ) : <>
            <li>एचडीएफसी बैंक के साथ आपकी टेलीफोनिक बातचीत के संदर्भ में और आवश्यकता विश्लेषण के दौरान आपके स्वैच्छिक इनपुट के अनुसार, आपने <b>आदित्य बिरला सुन लाइफ इन्शुरन्स </b> से <b>{user?.plan_name} </b> के लिए आवेदन किया है जो आपके जीवन बीमा उपयुक्तता प्रोफाइलर के आधार पर उपयुक्त है। यह <b>{user?.policy_term}</b> वर्षों की अवधि के लिए एक स्टैंड-अलोन उत्पाद है। प्रीमियम <b>{user.premium_amount}</b> है, साथ ही लागू करों के साथ जो आपको <b>{user?.payment_frequency}</b> के आधार पर <b>{user?.payment_term}</b> वर्षों के लिए भुगतान करने की आवश्यकता है। आप उत्पाद के सभी नियमों और शर्तों के बारे में जानने के लिए पॉलिसी दस्तावेज़ और लाभ चित्रण का संदर्भ ले सकते हैं और किसी भी मुद्दे के मामले में 30 दिनों की फ्री-लुक अवधि के दौरान बीमाकर्ता या बैंक से संपर्क कर सकते हैं।</li>
            {languageContent.hdfc_disclaimer_page.vrm.non_par_points.map(
                  (item) => (
                    <li>{item.content}</li>
                  )
                )}
            </>
          ) : null
        ) : null}
      </div>

      {showButtons && (
        <div className="floatingButton">
          <div style={{display: "flex", justifyContent: "center", marginBottom: "10px", }}>          
            <button className="" style={{backgroundColor: "#fff", display: "flex", justifyContent: "center", gap: "2px", alignItems: 'center', padding: '8px', border: '1px solid #c7222a', borderColor: "#c7222a", borderRadius: "6px", color: "#c7222a"}} 
              onClick={() => { template_hdfc_scripts(template) }}
              >
                <img
            src="./replay.png"
            className=""
            alt=""
            style={{ height: "1rem", width: "1rem" }}
          />
          {languageContent.buttons.replay}
            </button>
            </div> 
          <div style={{ display: "flex", justifyContent: "space-around" }}>
            <button className="backButton" onClick={handleDisagreeInformation}>
              {languageContent.buttons.disagree}
            </button>
            <button
              className={`${checked ? "myButton" : "disabled-button"} `}
              onClick={handleAgreeInformation}
            >
              {languageContent.buttons.agree}
            </button>
          </div>
          {/* {(user?.flow_type && user?.flow_type.toLowerCase() === 'hdfc') ? null : (<img
            src="./hand.png"
            className="submitHandIcon"
            alt=""
            style={{ height: "3rem", width: "3rem" }}
          />)} */}
        </div>
      )}
    </div>
  ) : (
    <LoaderComp />
  );
};
export default HdfcScripts;
